// Balança (dono, 26/10/2026: "os dois configurado em preferências"): como o
// peso da balança entra no pedido, para a loja inteira. A balança em si (cabo,
// marca, porta) é configurada no computador onde ela está, em Integração → Balança.
import { Scale } from "lucide-react";
import { useEffect, useState } from "react";

import { MODULOS_BALANCA, salvarPrefs, usePrefsBalanca } from "../balanca/preferencias";
import BlocoRecolhivel from "./BlocoRecolhivel";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}` });

const MODOS = [
  { id: "manual", titulo: "Manual", desc: "O operador põe o produto e toca em Ler balança." },
  { id: "automatico", titulo: "Automático", desc: "O peso entra sozinho quando firma (cerca de 1 segundo parado). Na pesagem rápida das Comandas, lança sozinho." },
];

export default function BalancaPreferencias({ toast }) {
  const prefs = usePrefsBalanca();
  const [produtos, setProdutos] = useState([]);
  const [minimo, setMinimo] = useState("");

  useEffect(() => { if (prefs) setMinimo(String(prefs.peso_minimo_g ?? 20)); }, [prefs]);
  useEffect(() => {
    fetch(`${API_URL}/api/products`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : []))
      .then((lista) => setProdutos((lista || []).filter((p) => p.usa_balanca && p.sale_unit === "kg")))
      .catch(() => setProdutos([]));
  }, []);

  const salvar = async (mudancas, titulo) => {
    try {
      await salvarPrefs(mudancas);
      toast({ title: titulo || "Balança salva" });
    } catch (e) {
      toast({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
    }
  };

  const modo = prefs?.modo || "manual";
  const modulos = prefs?.modulos || [];
  const alternarModulo = (key) => {
    const novo = modulos.includes(key) ? modulos.filter((m) => m !== key) : [...modulos, key];
    salvar({ modulos: novo }, "Módulos da balança salvos");
  };
  const resumo = prefs
    ? `${modo === "automatico" ? "Automático" : "Manual"} · mínimo ${prefs.peso_minimo_g} g · ${modulos.length ? MODULOS_BALANCA.filter((m) => modulos.includes(m.key)).map((m) => m.label).join(", ") : "nenhum módulo"}`
    : "Carregando…";

  return (
    <BlocoRecolhivel e2e="card-balanca" icone={Scale} titulo="Balança" carregando={!prefs} resumo={resumo}>
      <div className="space-y-5">
        <p className="text-sm text-muted-foreground">
          Vale para os produtos marcados <b>Pesar na balança</b> (Cardápio → Produtos → Configuração), nos computadores com a
          balança configurada em Configurações → Sistema → Integração → Balança.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {MODOS.map((m) => (
            <button key={m.id} type="button" onClick={() => modo !== m.id && salvar({ modo: m.id }, `Balança no modo ${m.titulo.toLowerCase()}`)}
              data-e2e={`balanca-modo-${m.id}`}
              className={`p-3 rounded-xl border text-left transition ${modo === m.id ? "border-primary bg-primary/5" : "hover:bg-muted/40"}`}>
              <span className="block text-sm font-semibold">{m.titulo}</span>
              <span className="block text-xs text-muted-foreground mt-0.5">{m.desc}</span>
            </button>
          ))}
        </div>

        <div>
          <p className="text-sm font-semibold">Onde a balança vale</p>
          <div className="flex flex-wrap gap-2 mt-2">
            {MODULOS_BALANCA.map((m) => (
              <button key={m.key} type="button" onClick={() => alternarModulo(m.key)} data-e2e={`balanca-modulo-${m.key}`}
                className={`h-8 px-3 rounded-full border text-xs font-semibold ${modulos.includes(m.key) ? "bg-primary text-primary-foreground border-primary" : "text-muted-foreground hover:bg-muted/40"}`}>
                {m.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className="block">
            <span className="text-sm font-semibold">Peso mínimo (g)</span>
            <span className="block text-xs text-muted-foreground">Abaixo disso a balança conta como vazia.</span>
            <input type="number" min="0" max="1000" value={minimo} onChange={(e) => setMinimo(e.target.value)} data-e2e="balanca-minimo"
              onBlur={() => { const g = Math.round(Number(minimo)); if (prefs && g !== prefs.peso_minimo_g && g >= 0 && g <= 1000) salvar({ peso_minimo_g: g }, "Peso mínimo salvo"); }}
              className="mt-1 w-32 h-10 px-3 rounded-lg border bg-background text-sm" />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Produto da pesagem rápida</span>
            <span className="block text-xs text-muted-foreground">O que entra na comanda ao pesar o prato (ex.: Comida por quilo).</span>
            <select value={prefs?.produto_pesagem_id || ""} data-e2e="balanca-produto-pesagem"
              onChange={(e) => salvar({ produto_pesagem_id: e.target.value || null }, "Produto da pesagem rápida salvo")}
              className="mt-1 w-full h-10 px-3 rounded-lg border bg-background text-sm">
              <option value="">{produtos.length ? "Escolha o produto" : "Nenhum produto marcado Pesar na balança"}</option>
              {produtos.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </label>
        </div>
      </div>
    </BlocoRecolhivel>
  );
}
